import React from 'react';
import { Tab, Tooltip, TabProps } from '@mui/material';

interface TabWithTooltipProps extends TabProps {
  tooltip: string;
  showTooltip?: boolean; // Optional prop to control when tooltip shows
}

const TabWithTooltip: React.FC<TabWithTooltipProps> = ({
  tooltip,
  showTooltip = true,
  disabled = false,
  children,
  ...tabProps
}) => {
  const tabElement = (
    <Tab disabled={disabled} {...tabProps}>
      {children}
    </Tab>
  );

  // Don't show tooltip if showTooltip is false
  if (!showTooltip) {
    return tabElement;
  }

  // For disabled tabs, wrap in span since Tooltip doesn't work on disabled elements
  if (disabled) {
    return (
      <Tooltip title={tooltip} placement="bottom">
        <span style={{ display: 'inline-block' }}>{tabElement}</span>
      </Tooltip>
    );
  }

  // Normal case with tooltip
  return (
    <Tooltip title={tooltip} placement="bottom">
      {tabElement}
    </Tooltip>
  );
};

export { TabWithTooltip };
